import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { Requisition } from '../../../class/requisition';
import { RequisitionService } from '../../../service/requisition/requisition.service';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { Router } from '@angular/router';
import { ProfileSurveyService } from '../../../service/profile-survey/profile-survey.service';
import { CustomerGuide } from '../../../class/customer-guide';
import { CustomerGuideService } from '../../../service/customer-guide/customer-guide.service';
import { HasPermissionService } from '../../../service/has-permission/has-permission.service';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { formatDate } from '../../../../../theme/functions/formatDate.function';

@Component({
  selector: 'app-resume-requisition',
  templateUrl: './resume-requisition.component.html',
  styleUrls: ['./resume-requisition.component.scss']
})
export class ResumeRequisitionComponent implements OnInit {
    @Input() typeGraph: string;
    public graph;
    public graph2;
    public loading = true;
    public page: number;
    public per_page: number;
    public filtersKanban: {key: string, value: string}[];
    public sort: string;
    public query: string;
    public filters: any[];
    public filters2: any[];

    public total: number;
    public totalLastMonth: number;
    public open: number;
    public close: number;
    public pause: number;

    constructor(
        public requisitionService: RequisitionService,
        public translate: TranslateService,
        public hasPermissionService: HasPermissionService,
        private notificationsService: NotificationsService
    ) {
        this.loading = true;
        this.page = 1;
        this.per_page = 10;
        this.sort = '-id';

        this.total = 0;
        this.totalLastMonth = 0;
    }

    ngOnInit() {
        let date = new Date();
        date.setMonth(date.getMonth() - 1)
        date.setDate(25);
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);

        this.filters = [];
        this.getBusinessFilter(this.filters);

        this.filters2 = [];
        
        this.getBusinessFilter(this.filters2);

        if(this.typeGraph == 'last month')
            this.filters2.push({key: 'requested_at-min', value: formatDate(date)});

        this.getResumeRequisition();
        
        // this.getResumeTotalRequisition();
    }

    /* public getResumeTotalRequisition() {
        this.loading = true;
        this.requisitionService.getResumeRequisition(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                this.loading = false;
                let labels = response.json().data.labels;
                let data = response.json().data.values;
                this.total = response.json().meta.total_filtered;
                this.graph = {
                    labels: labels,
                    datasets: [{
                        data: data,
                        backgroundColor: [
                            "#FF6384",
                            "#36A2EB",
                            "#ffed00",
                            "#9fe500"
                        ],
                        hoverBackgroundColor: [
                            "#FF6384",
                            "#36A2EB",
                            "#ffed00",
                            "#9fe500"
                        ]
                    }]
                };
            },
            error => {
                let msg = '';
                this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                    this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                        JSON.parse(error._body).errors.forEach(element => {
                            if (element.source) {
                                if (element.source.pointer) {
                                    this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                        msg = msg + res3 + ', ';
                                    });
                                }
                            }
                        });
                        this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                        // this.msg.emit( { severity: 'error', summary: 'Error' } );
                    });
                });
            }
        );
    } */

    public getResumeRequisition() {
        this.loading = true;
        this.requisitionService.getResumeRequisition(this.page, this.per_page, this.sort, this.query, this.filters2).toPromise().then(
            response => {
                this.loading = false;
                let labels = response.json().data.labels;
                let data = response.json().data.values;

                if(this.typeGraph == 'last month')    
                    this.totalLastMonth = response.json().meta.total_filtered;
                else
                    this.total = response.json().meta.total_filtered;
                
                this.graph = {
                    labels: labels,
                    datasets: [{
                        data: data,
                        backgroundColor: [
                            "#FF6384",
                            "#36A2EB",
                            "#ffed00",
                            "#9fe500"
                        ],
                        hoverBackgroundColor: [
                            "#FF6384",
                            "#36A2EB",
                            "#ffed00",
                            "#9fe500"
                        ]
                    }]
                };
            },
            error => {
                let msg = '';
                this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                    this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                        JSON.parse(error._body).errors.forEach(element => {
                            if (element.source) {
                                if (element.source.pointer) {
                                    this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                        msg = msg + res3 + ', ';
                                    });
                                }
                            }
                        });
                        this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                        // this.msg.emit( { severity: 'error', summary: 'Error' } );
                    });
                });
            }
        );
    }

    public getBusinessFilter(filter) {
        let business_id = ['0'];
        if (this.hasPermission('get contracts Redes Humanas'))
            business_id.push('1');

        if (this.hasPermission('get contracts Synergo'))
            business_id.push('2');
            
        filter.push({ key: 'business_id-in', value: business_id.toString() });

        // filter.push({ key: 'business_id-in', value: '2' });
    }

    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/requisitions/resume-requisition/resume-requisition.component.ts